import { render } from "./RotatingTopPlayer.vue?vue&type=template&id=3c63172e&scoped=true&ts=true"
import script from "./RotatingTopPlayer.vue?vue&type=script&lang=ts"
export * from "./RotatingTopPlayer.vue?vue&type=script&lang=ts"

import "./RotatingTopPlayer.vue?vue&type=style&index=0&id=3c63172e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c63172e"]])

export default __exports__